import React from 'react';
// feature fleet-profile
import { ServiceIssueReport } from '../components/service-issue-report';
//////////////////////////////////////////////////

const Component = ({
  shared,
  isOpened,
  fleetType,
  configGroup,
  isReadOnlyMode,
  withoutAddition,
  primaryObjectGuid,
  primaryObjectUnitId,
  primaryObjectBranchGuid,
  handleToggleFormGroupTable,
  changeFleetServiceIssueStatusRequest,
}) => (
  <ServiceIssueReport
    shared={shared}
    isOpened={isOpened}
    entityType={fleetType}
    configGroup={configGroup}
    isReadOnlyMode={isReadOnlyMode}
    withoutAddition={withoutAddition}
    primaryObjectGuid={primaryObjectGuid}
    primaryObjectUnitId={primaryObjectUnitId}
    primaryObjectBranchGuid={primaryObjectBranchGuid}
    changeFleetServiceIssueStatusRequest={changeFleetServiceIssueStatusRequest}
    handleToggleFormGroup={() => handleToggleFormGroupTable('fleetServiceIssue')}
  />
);

export const fleetServiceIssueSettings = {
  Component,
  groupName: 'fleetServiceIssue',
};
